
import { defineComponent, PropType, Ref } from 'vue'
import { IdfToggle } from '@invivodf/ui-kit'

export type ReactiveToggle = {
  title: string
  isActive: Ref<boolean>
  isDisabled: Ref<boolean>
  isAuthorized: Ref<boolean>
  error: Ref<string | null>
  init: () => Promise<void>
  toggle: () => Promise<void>
}

export default defineComponent({
  name: 'PParametersToggle',
  components: { IdfToggle },
  props: {
    title: {
      type: String as PropType<string>,
      required: true,
    },
    error: {
      type: String as PropType<string | null>,
      required: false,
      defaultValue: null,
    },
    active: {
      type: Boolean as PropType<boolean>,
      required: false,
      defaultValue: false,
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      required: false,
      defaultValue: false,
    },
  },
  setup(_, { emit }) {
    const onToggle = async (value: boolean) => {
      emit('toggle', value)
    }

    return { onToggle }
  },
})
